__turbopack_context__.v({
  "control": "PaginationNav-module-scss-module__QAo8Tq__control",
  "controlDisabled": "PaginationNav-module-scss-module__QAo8Tq__controlDisabled",
  "ellipsis": "PaginationNav-module-scss-module__QAo8Tq__ellipsis",
  "item": "PaginationNav-module-scss-module__QAo8Tq__item",
  "list": "PaginationNav-module-scss-module__QAo8Tq__list",
  "nav": "PaginationNav-module-scss-module__QAo8Tq__nav",
  "page": "PaginationNav-module-scss-module__QAo8Tq__page",
  "pageCurrent": "PaginationNav-module-scss-module__QAo8Tq__pageCurrent",
});
